import { useGetSectionByName } from '@bpm-web-app/swr-hooks';
import { createAppRoutes } from '@bpm-web-app/utils';
import { ClickableGenres } from '../../clickable-genres/clickable-genres';
import SeeMoreLayout from '../../see-more-layout/see-more-layout';

export const NewFeaturedPacks = () => {
    const { data: sectionData } = useGetSectionByName('Featured Packs', 'new');

    return (
        <SeeMoreLayout
            contentType="pack"
            pageTitle="New Featured Packs"
            count={sectionData?.items.length || 0}
            itemBasePath={createAppRoutes.packs}
            data={
                sectionData?.items?.map((item) => ({
                    id: item.id,
                    image_url: item.artwork_url,
                    description: <ClickableGenres genres={item.Genre} />,
                    title: item.name,
                    slug: item.slug,
                    demo_file_url: item.demo_file_url,
                    demo_wave: item.demo_wave,
                    demo_file_url_2: item.demo_file_url_2,
                    demo_wave_2: item.demo_wave_2,
                })) || []
            }
        />
    );
};
